import React from 'react'
import { Box } from "@chakra-ui/react";
import RingLoader from "react-spinners/RingLoader";

function Loader(props) {
    return (
        <Box className={props.isLoading ? "lodder-display" : "lodder-disable"}>
            <RingLoader color="#5e5e72" loading={props.isLoading} size={50} />
      </Box>
    )
}

export default Loader
